import React from 'react';
import {useAppSelector} from "../store/hooks/redux";
import {Navigate, Outlet} from "react-router-dom";
import {AuthStatus} from "../models/StoreModels";
import Loading from "./Loading/Loading";

const PrivateRouter = () => {
    const {authStatus} = useAppSelector(state => state.userReducer)

    if (authStatus === AuthStatus.Loading) {
        return <Loading/>;
    }

    if (authStatus === AuthStatus.Unauthorized) {
        return <Navigate to="/" replace/>;
    }

    return <Outlet/>;
};

export default PrivateRouter;